import { z } from 'zod';

/**
 * GraphQL Node Validator
 * Validates GraphQL node configuration
 */
export const graphqlValidator = z.object({
  url: z.string().url('Must be a valid URL').min(1, 'URL is required'),
  
  authentication: z.enum(['none', 'bearer', 'apiKey', 'basicAuth', 'oauth2', 'credential']),
  
  // Authentication fields (optional based on auth type)
  bearerToken: z.string().optional(),
  apiKeyHeader: z.string().optional(),
  apiKeyValue: z.string().optional(),
  basicAuthUser: z.string().optional(),
  basicAuthPassword: z.string().optional(),
  credentialId: z.string().optional(),
  
  operation: z.enum(['query', 'mutation']),
  
  query: z.string().min(1, 'GraphQL query cannot be empty'),
  
  variables: z.string().optional().refine(
    (val) => {
      if (!val || val.trim() === '') return true;
      try {
        JSON.parse(val);
        return true;
      } catch {
        return false;
      }
    },
    { message: 'Variables must be valid JSON' }
  ),
  
  sendHeaders: z.boolean().optional(),
  headerParameters: z.any().optional(),
  
  // Options
  timeout: z.number().min(1000).max(300000).optional(),
  enableRetry: z.boolean().optional(),
  maxRetries: z.number().min(1).max(10).optional(),
  enablePagination: z.boolean().optional(),
  cursorPath: z.string().optional(),
  hasNextPagePath: z.string().optional(),
  maxPages: z.number().min(1).max(1000).optional(),
  cursorVariable: z.string().optional(),
  fullResponse: z.boolean().optional(),
  allowUnauthorizedCerts: z.boolean().optional(),
});

export type GraphQLNodeConfig = z.infer<typeof graphqlValidator>;

export default graphqlValidator;
